import { reset } from 'redux-form'
import lodash from 'lodash';

import { periodServices } from '../services';
import { periodConstants } from '../constants';
import { loader, alert as customAlert } from 'helpers';
import i18n from 'i18n';

const defaultFailedText = 'api_messages.SOMETHING_WENT_WRONG';

export const periodAction = {
   getRewardList,
   getPeriodList,
   addPeriod,
   editPeriod,
   deletePeriod,
};

function getRewardList(params) {
   return dispatch => {
      periodServices.getRewardList(params)
         .then(
            response => {
               console.log('response getRewardList action', response);
               if (response.status) {
                  if (lodash.has(response, 'data')) {
                     dispatch(success(response.data));
                  }
               } else {
                  if (!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            // loader(dispatch, false)
         })
   };

   function success(data) {
      return { type: periodConstants.GET_DROPDOWN_REWARD_LIST_SUCCESS, data }
   }
}

function getPeriodList(params, tableReset = false) {
   return dispatch => {
      dispatch({ type: periodConstants.SHOW_LOADER })

      periodServices.getPeriodList(params)
         .then(
            response => {
               if (response.status) {
                  dispatch({ type: periodConstants.GET_PERIOD_SUCCESS, data: response.data.data, total: response.data.total, tableFilter: params });
                  // if (tableReset) {
                  //    dispatch({ type: whitelistConstants.TABLE_GET_LIST_DATAS_RESET });
                  // }
               } else {
                  if (!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            dispatch({ type: periodConstants.HIDE_LOADER })
         })
   };
}

function addPeriod(params) {
   // console.log('addNewWhitelist action');
   // console.log('params :', params);
   return dispatch => {
      loader(dispatch, true)

      periodServices.addPeriod(params)
         .then(
            response => {
               //console.log(response)
               if (response.status) {
                  dispatch({
                     type: periodConstants.ADD_PERIOD_SUCCESS
                  });

                  customAlert(dispatch, 'success', i18n.t('warning_messages.period_was_created'));
               } else {
                  if (!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               //console.log(error)
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            loader(dispatch, false)
         })
   };

   //function success(tmp) { return { type: whitelistConstants.ADD_NEW_WHITELIST_SUCCESS, tmp } }
}

function editPeriod(params) {
   return dispatch => {
      loader(dispatch, true)
      console.log('params edit ', params);
      periodServices.editPeriod(params)
         .then(
            response => {
               if (response.status) {
                  dispatch(success(response.data));
                  customAlert(dispatch, 'success', i18n.t('warning_messages.period_was_updated'));
               } else {
                  if (!response.unAlert) customAlert(dispatch, 'error', i18n.t(`api_messages.${response.message.toString()}`))
               }
            },
            error => {
               customAlert(dispatch, 'error', i18n.t(defaultFailedText))
            }
         ).then(() => {
            loader(dispatch, false)
         })
   };
   function success(tmp) { return { type: periodConstants.EDIT_PERIOD_SUCCESS, tmp } }
}

function deletePeriod(params) {
   //console.log('action',params);
   return dispatch => {
      loader(dispatch, true)
      periodServices.deletePeriod(params)
         .then(
            (response) => {
               //console.log(response);
               if (response.status) {
                  dispatch({ type: periodConstants.DELETE_PERIOD_SUCCESS })
                  customAlert(
                     dispatch,
                     "success",
                     i18n.t("warning_messages.period_was_deleted")
                  )
               } else {
                  if (!response.unAlert)
                     customAlert(
                        dispatch,
                        "error",
                        i18n.t(`api_messages.${response.message.toString()}`)
                     )
               }
            },
            (error) => {
               customAlert(dispatch, "error", i18n.t(defaultFailedText))
            }
         )
         .then(() => {
            loader(dispatch, false)
         })

   };
}


